import type { FieldProps } from './TextField';
import { useFormField } from '../../hooks/useFormField';
import { QuestionWrapper } from '../QuestionWrapper';

export function TextAreaField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);
  const rows = fieldSchema.rows ?? 5;

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer">
          <textarea
            id={`input-${field.question.id}`}
            rows={rows}
            cols={30}
            value={String(field.answer ?? '')}
            onChange={(e) => field.setAnswer(e.target.value)}
          />
        </div>
      </div>
    </QuestionWrapper>
  );
}
